/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway Cards
 * Bank Backoffice Gateway Cards
 *
 * The version of the OpenAPI document: 3.0
 * Contact: radomil.janicek@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AccountProductCodeV3 = {
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    SAVINGS_ACCOUNT_GOAL: 'OP_SAVINGS_ACCOUNT_GOAL',
    SAVINGS_ACCOUNT_CASH_RESERVE: 'OP_SAVINGS_ACCOUNT_CASH_RESERVE',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED',
    SAVINGS_GOAL_SHARED: 'OP_SAVINGS_GOAL_SHARED',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_GOAL_CHILD: 'OP_SAVINGS_ACCOUNT_GOAL_CHILD'
} as const;

export type AccountProductCodeV3 = typeof AccountProductCodeV3[keyof typeof AccountProductCodeV3];


/**
 * The adviser to whom the application is linked
 * @export
 * @interface AdvisorV3
 */
export interface AdvisorV3 {
    /**
     * ID from the external system.
     * @type {number}
     * @memberof AdvisorV3
     */
    'fipId': number;
    /**
     * Pid UUID
     * @type {string}
     * @memberof AdvisorV3
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorV3
     */
    'functionId'?: string;
}
/**
 * 
 * @export
 * @interface ApplicationAdvisorV3
 */
export interface ApplicationAdvisorV3 {
    /**
     * FIP ID of the advisor.
     * @type {number}
     * @memberof ApplicationAdvisorV3
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationAdvisorV3
     */
    'name'?: string;
}
/**
 * Application list item.
 * @export
 * @interface ApplicationListItemV3
 */
export interface ApplicationListItemV3 {
    /**
     * Unique identifier of the application
     * @type {string}
     * @memberof ApplicationListItemV3
     */
    'applicationUuid': string;
    /**
     * 
     * @type {ProductTypeV2x0}
     * @memberof ApplicationListItemV3
     */
    'product': ProductTypeV2x0;
    /**
     * 
     * @type {OnboardingApplicationStatusV2x0}
     * @memberof ApplicationListItemV3
     */
    'status': OnboardingApplicationStatusV2x0;
    /**
     * 
     * @type {ApplicationMainClientV3}
     * @memberof ApplicationListItemV3
     */
    'mainClient': ApplicationMainClientV3;
    /**
     * 
     * @type {string}
     * @memberof ApplicationListItemV3
     */
    'expiration': string;
    /**
     * 
     * @type {ApplicationAdvisorV3}
     * @memberof ApplicationListItemV3
     */
    'advisor': ApplicationAdvisorV3;
    /**
     * 
     * @type {string}
     * @memberof ApplicationListItemV3
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationListItemV3
     */
    'updatedAt': string;
}


/**
 * Application main client.
 * @export
 * @interface ApplicationMainClientV3
 */
export interface ApplicationMainClientV3 {
    /**
     * PID UUID of the client.
     * @type {string}
     * @memberof ApplicationMainClientV3
     */
    'pid': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationMainClientV3
     */
    'name': string;
}
/**
 * Request with application list filter by pidUuid, which uses OR logic for filter\'đ fields.
 * @export
 * @interface ApplicationsListByPidUuidRequestV3
 */
export interface ApplicationsListByPidUuidRequestV3 {
    /**
     * 
     * @type {SortV2x0}
     * @memberof ApplicationsListByPidUuidRequestV3
     */
    'sort'?: SortV2x0;
    /**
     * 
     * @type {PageableV0x2}
     * @memberof ApplicationsListByPidUuidRequestV3
     */
    'pageable': PageableV0x2;
}
/**
 * Request with application list filter, which uses OR logic for filter\'s fields.
 * @export
 * @interface ApplicationsListRequestV3
 */
export interface ApplicationsListRequestV3 {
    /**
     * 
     * @type {Array<ProductTypeV2x0>}
     * @memberof ApplicationsListRequestV3
     */
    'products'?: Array<ProductTypeV2x0>;
    /**
     * 
     * @type {Array<OnboardingApplicationStatusV2x0>}
     * @memberof ApplicationsListRequestV3
     */
    'statuses'?: Array<OnboardingApplicationStatusV2x0>;
    /**
     * 
     * @type {string}
     * @memberof ApplicationsListRequestV3
     */
    'dateCreated'?: string;
    /**
     * 
     * @type {SortV2x0}
     * @memberof ApplicationsListRequestV3
     */
    'sort'?: SortV2x0;
    /**
     * 
     * @type {PageableV0x2}
     * @memberof ApplicationsListRequestV3
     */
    'pageable': PageableV0x2;
}
/**
 * Response containing list of searched applications.
 * @export
 * @interface ApplicationsListResponseV3
 */
export interface ApplicationsListResponseV3 {
    /**
     * 
     * @type {Array<ApplicationListItemV3>}
     * @memberof ApplicationsListResponseV3
     */
    'applications': Array<ApplicationListItemV3>;
    /**
     * 
     * @type {PageableResponseV0x2}
     * @memberof ApplicationsListResponseV3
     */
    'pageable': PageableResponseV0x2;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicationsSortFieldNameV2x0 = {
    APPLICATION_UUID: 'APPLICATION_UUID',
    PRODUCT: 'PRODUCT',
    STATUS: 'STATUS',
    MAIN_CLIENT_PID: 'MAIN_CLIENT_PID',
    MAIN_CLIENT_NAME: 'MAIN_CLIENT_NAME',
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT'
} as const;

export type ApplicationsSortFieldNameV2x0 = typeof ApplicationsSortFieldNameV2x0[keyof typeof ApplicationsSortFieldNameV2x0];


/**
 * 
 * @export
 * @interface BackOfficeOnboardingApplicationAccountV3
 */
export interface BackOfficeOnboardingApplicationAccountV3 {
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOnboardingApplicationAccountV3
     */
    'bankAccountIban': string;
}
/**
 * 
 * @export
 * @interface BackOfficeOnboardingApplicationBundleV3
 */
export interface BackOfficeOnboardingApplicationBundleV3 {
    /**
     * 
     * @type {BundleProductCodeV2x0}
     * @memberof BackOfficeOnboardingApplicationBundleV3
     */
    'bundleProductCode'?: BundleProductCodeV2x0;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOnboardingApplicationBundleV3
     */
    'advisorCommissionReduction'?: string;
}


/**
 * Contains information about cards on the application.
 * @export
 * @interface BackOfficeOnboardingApplicationCardV3
 */
export interface BackOfficeOnboardingApplicationCardV3 {
    /**
     * 
     * @type {CardTypeV1x3}
     * @memberof BackOfficeOnboardingApplicationCardV3
     */
    'cardType': CardTypeV1x3;
    /**
     * 
     * @type {CardDesignV1x3}
     * @memberof BackOfficeOnboardingApplicationCardV3
     */
    'cardDesign': CardDesignV1x3;
}


/**
 * 
 * @export
 * @interface BackOfficeOnboardingApplicationMainAccountV3
 */
export interface BackOfficeOnboardingApplicationMainAccountV3 {
    /**
     * 
     * @type {AccountProductCodeV3}
     * @memberof BackOfficeOnboardingApplicationMainAccountV3
     */
    'accountProductCode'?: AccountProductCodeV3;
    /**
     * Array of reserved IBANs for the new account.
     * @type {Array<BackOfficeOnboardingApplicationAccountV3>}
     * @memberof BackOfficeOnboardingApplicationMainAccountV3
     */
    'reservedAccounts'?: Array<BackOfficeOnboardingApplicationAccountV3>;
    /**
     * 
     * @type {BackOfficeOnboardingApplicationAccountV3}
     * @memberof BackOfficeOnboardingApplicationMainAccountV3
     */
    'selectedAccount'?: BackOfficeOnboardingApplicationAccountV3;
    /**
     * 
     * @type {Array<BackOfficeOnboardingApplicationCardV3>}
     * @memberof BackOfficeOnboardingApplicationMainAccountV3
     */
    'cards'?: Array<BackOfficeOnboardingApplicationCardV3>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BundleProductCodeV2x0 = {
    INDIVIDUAL: 'OB_BUNDLE_INDIVIDUAL',
    COUPLE: 'OB_BUNDLE_COUPLE',
    FAMILY: 'OB_BUNDLE_FAMILY'
} as const;

export type BundleProductCodeV2x0 = typeof BundleProductCodeV2x0[keyof typeof BundleProductCodeV2x0];


/**
 * Card design.
 * @export
 * @enum {string}
 */

export const CardDesignV1x3 = {
    VIRTUAL: 'VIRTUAL',
    FOUNDER: 'FOUNDER',
    DISPOSABLE: 'DISPOSABLE',
    STANDARD_DARK_BLUE: 'STANDARD_DARK_BLUE',
    STANDARD_TURQUOISE: 'STANDARD_TURQUOISE',
    STANDARD_WHITE: 'STANDARD_WHITE',
    STANDARD_CORAL: 'STANDARD_CORAL',
    KIDS_THUMB_UP: 'KIDS_THUMB_UP',
    KIDS_GIRL: 'KIDS_GIRL',
    KIDS_FLIGHT: 'KIDS_FLIGHT',
    KIDS_SKATE: 'KIDS_SKATE',
    COMMON_LO: 'COMMON_LO',
    COMMON_VE: 'COMMON_VE'
} as const;

export type CardDesignV1x3 = typeof CardDesignV1x3[keyof typeof CardDesignV1x3];


/**
 * Card item.
 * @export
 * @interface CardItemV3
 */
export interface CardItemV3 {
    /**
     * UUID of the card.
     * @type {string}
     * @memberof CardItemV3
     */
    'bankCardUuid': string;
    /**
     * UUID of the card holder.
     * @type {string}
     * @memberof CardItemV3
     */
    'pidUuid': string;
    /**
     * 
     * @type {CardStatusV5x0}
     * @memberof CardItemV3
     */
    'status': CardStatusV5x0;
    /**
     * 
     * @type {VisaCardStatusV3}
     * @memberof CardItemV3
     */
    'visaStatus': VisaCardStatusV3;
    /**
     * Masked PAN of the card.
     * @type {string}
     * @memberof CardItemV3
     */
    'maskedPan': string;
    /**
     * Phone number of the card holder.
     * @type {string}
     * @memberof CardItemV3
     */
    'phone': string;
    /**
     * Email of the card holder.
     * @type {string}
     * @memberof CardItemV3
     */
    'email': string;
}


/**
 * Status of the card. * UNACTIVATED - Card was sent to customer, waiting for activation. * ACTIVE - Card is in use by customer. * SUSPENDED - Card was temporarily blocked. Authorizations are declined. * TERMINATED - Card was manually terminated by user, renewed/replaced or expired. Card can\'t be use anymore. 
 * @export
 * @enum {string}
 */

export const CardStatusV5x0 = {
    UNACTIVATED: 'UNACTIVATED',
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    TERMINATED: 'TERMINATED'
} as const;

export type CardStatusV5x0 = typeof CardStatusV5x0[keyof typeof CardStatusV5x0];


/**
 * Card types. * VIRTUAL - Virtual card has no plastic, it exists just in application. * STANDARD - Standard plastic card. * PREMIUM - Plastic card for premium customers. * KIDS - Plastic card for kids, with various kid designs and limited rights. * COMMON - Plastic card for shared accounts. * DISPOSABLE - Virtual card which is after every card payment terminated. 
 * @export
 * @enum {string}
 */

export const CardTypeV1x3 = {
    VIRTUAL: 'VIRTUAL',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD',
    KIDS: 'KIDS',
    COMMON: 'COMMON',
    DISPOSABLE: 'DISPOSABLE'
} as const;

export type CardTypeV1x3 = typeof CardTypeV1x3[keyof typeof CardTypeV1x3];


/**
 * Request with card list filter, which uses AND logic for filter\'s fields and sorted DESC by created at.
 * @export
 * @interface CardsListRequestV3
 */
export interface CardsListRequestV3 {
    /**
     * Filter cards via bankCardUuid. Equal.
     * @type {string}
     * @memberof CardsListRequestV3
     */
    'bankCardUuid'?: string;
    /**
     * Filter cards via pidUuid of the card holder. Equal.
     * @type {string}
     * @memberof CardsListRequestV3
     */
    'pidUuid'?: string;
    /**
     * Filter cards which are in given status. If it is empty, then all statuses are returned. Contains.
     * @type {Array<CardStatusV5x0>}
     * @memberof CardsListRequestV3
     */
    'status'?: Array<CardStatusV5x0>;
    /**
     * Filter cards which are in given visa status. If it is empty, then all statuses are returned. Contains.
     * @type {Array<VisaCardStatusV3>}
     * @memberof CardsListRequestV3
     */
    'visaStatus'?: Array<VisaCardStatusV3>;
    /**
     * Filter cards via phone number of the card holder. Equal.
     * @type {string}
     * @memberof CardsListRequestV3
     */
    'phone'?: string;
    /**
     * Filter cards via email of the card holder. Equal.
     * @type {string}
     * @memberof CardsListRequestV3
     */
    'email'?: string;
    /**
     * 
     * @type {Pageable1V1x0}
     * @memberof CardsListRequestV3
     */
    'pageable': Pageable1V1x0;
}
/**
 * Response containing list of searched cards.
 * @export
 * @interface CardsListResponseV3
 */
export interface CardsListResponseV3 {
    /**
     * 
     * @type {Array<CardItemV3>}
     * @memberof CardsListResponseV3
     */
    'cards': Array<CardItemV3>;
    /**
     * 
     * @type {PageableResponse1V1x0}
     * @memberof CardsListResponseV3
     */
    'pageable': PageableResponse1V1x0;
}
/**
 * The Garant to whom the application is linked
 * @export
 * @interface GarantV3
 */
export interface GarantV3 {
    /**
     * ID from the external system.
     * @type {number}
     * @memberof GarantV3
     */
    'fipId': number;
    /**
     * Pid UUID
     * @type {string}
     * @memberof GarantV3
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GarantV3
     */
    'pfsAdvisorFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GarantV3
     */
    'functionId'?: string;
}
/**
 * 
 * @export
 * @interface GetBackOfficeOnboardingApplicationResponseV3
 */
export interface GetBackOfficeOnboardingApplicationResponseV3 {
    /**
     * 
     * @type {UserV3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'user': UserV3;
    /**
     * 
     * @type {AdvisorV3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'advisor': AdvisorV3;
    /**
     * 
     * @type {GarantV3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'garant': GarantV3;
    /**
     * UUID of the application
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'applicationUuid': string;
    /**
     * FIP process ID
     * @type {number}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'processId': number;
    /**
     * 
     * @type {OnboardingApplicationStatusV2x0}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'onboardingApplicationStatus': OnboardingApplicationStatusV2x0;
    /**
     * UUID of client
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'clientPidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'applicationExpirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'signatureExpirationDate'?: string;
    /**
     * 
     * @type {BackOfficeOnboardingApplicationBundleV3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'bundle': BackOfficeOnboardingApplicationBundleV3;
    /**
     * 
     * @type {BackOfficeOnboardingApplicationMainAccountV3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'mainAccount': BackOfficeOnboardingApplicationMainAccountV3;
    /**
     * 
     * @type {OnboardingApplicationSignatureMethodV2x0}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'selectedSignatureMethod'?: OnboardingApplicationSignatureMethodV2x0;
    /**
     * ID of sign operation related to this onboarding application
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'signOperationUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV3
     */
    'marketingAction'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OnboardingApplicationSignatureMethodV2x0 = {
    MOBILE_APPLICATION: 'MOBILE_APPLICATION',
    ANAKIN: 'ANAKIN'
} as const;

export type OnboardingApplicationSignatureMethodV2x0 = typeof OnboardingApplicationSignatureMethodV2x0[keyof typeof OnboardingApplicationSignatureMethodV2x0];


/**
 * Status of the onboarding application.
 * @export
 * @enum {string}
 */

export const OnboardingApplicationStatusV2x0 = {
    IN_PROGRESS: 'IN_PROGRESS',
    SIGNATURE_IN_PREPARATION: 'SIGNATURE_IN_PREPARATION',
    SIGNATURE_WAITING_FOR_CLIENT: 'SIGNATURE_WAITING_FOR_CLIENT',
    SIGNED: 'SIGNED',
    BANK_PROCESSING: 'BANK_PROCESSING',
    BANK_PROCESSING_PAUSED: 'BANK_PROCESSING_PAUSED',
    COMPLETED: 'COMPLETED',
    CANCELLED_BY_ADVISOR: 'CANCELLED_BY_ADVISOR',
    CANCELLED_BY_CLIENT: 'CANCELLED_BY_CLIENT',
    CANCELLED_BY_BANK: 'CANCELLED_BY_BANK',
    EXPIRED: 'EXPIRED',
    EXPIRED_NOT_SIGNED: 'EXPIRED_NOT_SIGNED',
    PRODUCT_ACTIVATION_FAILED: 'PRODUCT_ACTIVATION_FAILED'
} as const;

export type OnboardingApplicationStatusV2x0 = typeof OnboardingApplicationStatusV2x0[keyof typeof OnboardingApplicationStatusV2x0];


/**
 * Token operation type according operations from Visa API.
 * @export
 * @enum {string}
 */

export const OperationTypeV3 = {
    DELETE: 'DELETE',
    SUSPEND: 'SUSPEND',
    RESUME: 'RESUME'
} as const;

export type OperationTypeV3 = typeof OperationTypeV3[keyof typeof OperationTypeV3];


/**
 * Object for search paging.
 * @export
 * @interface Pageable1V1x0
 */
export interface Pageable1V1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof Pageable1V1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof Pageable1V1x0
     */
    'pageSize': number;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponse1V1x0
 */
export interface PageableResponse1V1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponse1V1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponse1V1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponse1V1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponse1V1x0
     */
    'totalSize': number;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV0x2
 */
export interface PageableResponseV0x2 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV0x2
 */
export interface PageableV0x2 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV0x2
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV0x2
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProductTypeV2x0 = {
    PERSONAL_CURRENT_ACCOUNT: 'PERSONAL_CURRENT_ACCOUNT',
    PERSONAL_SAVING_ACCOUNT: 'PERSONAL_SAVING_ACCOUNT',
    SHARED_CURRENT_ACCOUNT: 'SHARED_CURRENT_ACCOUNT',
    SHARED_SAVING_ACCOUNT: 'SHARED_SAVING_ACCOUNT',
    CHILD_CURRENT_ACCOUNT: 'CHILD_CURRENT_ACCOUNT',
    BUNDLE_SINGLE: 'BUNDLE_SINGLE',
    BUNDLE_COUPLE: 'BUNDLE_COUPLE',
    BUNDLE_FAMILY: 'BUNDLE_FAMILY'
} as const;

export type ProductTypeV2x0 = typeof ProductTypeV2x0[keyof typeof ProductTypeV2x0];


/**
 * Card security types. * ATM - ATM withdrawals. * CONTACTLESS - Contactless card\'s transactions. * ECOMMERCE - Online transactions (e.g. eshops). * MAG_STRIPE - Mag-stripe card\'s transactions. * MCC - Merchant category code restrictions. * DCC - Dynamic currency conversion. 
 * @export
 * @enum {string}
 */

export const SecurityTypeV1x3 = {
    ATM: 'ATM',
    CONTACTLESS: 'CONTACTLESS',
    ECOMMERCE: 'ECOMMERCE',
    MAG_STRIPE: 'MAG_STRIPE',
    MCC: 'MCC',
    DCC: 'DCC'
} as const;

export type SecurityTypeV1x3 = typeof SecurityTypeV1x3[keyof typeof SecurityTypeV1x3];


/**
 * 
 * @export
 * @interface SetApplicationStatusRequestV3
 */
export interface SetApplicationStatusRequestV3 {
    /**
     * 
     * @type {OnboardingApplicationStatusV2x0}
     * @memberof SetApplicationStatusRequestV3
     */
    'applicationStatus': OnboardingApplicationStatusV2x0;
}


/**
 * Request to set new daily card limit.
 * @export
 * @interface SetLimitRequestV3
 */
export interface SetLimitRequestV3 {
    /**
     * New amount of the daily card limit.
     * @type {number}
     * @memberof SetLimitRequestV3
     */
    'amount': number;
}
/**
 * Request for enabling or disabling the given security.
 * @export
 * @interface SetSecurityRequestV3
 */
export interface SetSecurityRequestV3 {
    /**
     * 
     * @type {SecurityTypeV1x3}
     * @memberof SetSecurityRequestV3
     */
    'securityType': SecurityTypeV1x3;
    /**
     * Boolean if the security should be enabled (true) or disabled (false).
     * @type {boolean}
     * @memberof SetSecurityRequestV3
     */
    'value': boolean;
}


/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV2x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV2x0 = typeof SortOrderTypeV2x0[keyof typeof SortOrderTypeV2x0];


/**
 * Sort via given name and order type.
 * @export
 * @interface SortV2x0
 */
export interface SortV2x0 {
    /**
     * 
     * @type {ApplicationsSortFieldNameV2x0}
     * @memberof SortV2x0
     */
    'name': ApplicationsSortFieldNameV2x0;
    /**
     * 
     * @type {SortOrderTypeV2x0}
     * @memberof SortV2x0
     */
    'order': SortOrderTypeV2x0;
}


/**
 * Logged user that created the application
 * @export
 * @interface UserV3
 */
export interface UserV3 {
    /**
     * ID from the external system.
     * @type {number}
     * @memberof UserV3
     */
    'fipId': number;
    /**
     * Pid UUID
     * @type {string}
     * @memberof UserV3
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserV3
     */
    'headquartersFlag'?: boolean;
}
/**
 * Status of the card in VISA:  - `ACTIVATING` - card is being activated  - `ACTIVE` - card is active  - `DISABLING` - card is being disabled  - `DISABLED` - card is disabled 
 * @export
 * @enum {string}
 */

export const VisaCardStatusV3 = {
    ACTIVATING: 'ACTIVATING',
    ACTIVE: 'ACTIVE',
    DISABLING: 'DISABLING',
    DISABLED: 'DISABLED'
} as const;

export type VisaCardStatusV3 = typeof VisaCardStatusV3[keyof typeof VisaCardStatusV3];




/**
 * CardsApi - axios parameter creator
 * @export
 */
export const CardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate unactivated card. It will switch to ACTIVE status and customer can use it for payments.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCardV3: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('activateCardV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('activateCardV3', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('activateCardV3', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards/v3/cards/{bankCardUuid}/activate`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all cards filtered by filter in the request.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {CardsListRequestV3} cardsListRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsListV3: async (xCorrelationId: string, cardsListRequestV3: CardsListRequestV3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getCardsListV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'cardsListRequestV3' is not null or undefined
            assertParamExists('getCardsListV3', 'cardsListRequestV3', cardsListRequestV3)
            const localVarPath = `/bank-backofficegateway-cards/v3/cards/click-to-pay/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardsListRequestV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set new card\'s daily limit.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {SetLimitRequestV3} setLimitRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCardLimitV3: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, setLimitRequestV3: SetLimitRequestV3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('setCardLimitV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('setCardLimitV3', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('setCardLimitV3', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'setLimitRequestV3' is not null or undefined
            assertParamExists('setCardLimitV3', 'setLimitRequestV3', setLimitRequestV3)
            const localVarPath = `/bank-backofficegateway-cards/v3/cards/{bankCardUuid}/limit`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setLimitRequestV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable or enable given card security.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {SetSecurityRequestV3} setSecurityRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCardSecurityV3: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, setSecurityRequestV3: SetSecurityRequestV3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('setCardSecurityV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('setCardSecurityV3', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('setCardSecurityV3', 'clientPidUuid', clientPidUuid)
            // verify required parameter 'setSecurityRequestV3' is not null or undefined
            assertParamExists('setCardSecurityV3', 'setSecurityRequestV3', setSecurityRequestV3)
            const localVarPath = `/bank-backofficegateway-cards/v3/cards/{bankCardUuid}/set-security`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSecurityRequestV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate card - it will switch to TERMINATED status and it won\'t be functional anymore.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCardV3: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('terminateCardV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('terminateCardV3', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('terminateCardV3', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards/v3/cards/{bankCardUuid}/terminate`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unblock PIN on the given card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPinV3: async (xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('unblockPinV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'bankCardUuid' is not null or undefined
            assertParamExists('unblockPinV3', 'bankCardUuid', bankCardUuid)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('unblockPinV3', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards/v3/cards/{bankCardUuid}/unblock-pin`
                .replace(`{${"bankCardUuid"}}`, encodeURIComponent(String(bankCardUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardsApi - functional programming interface
 * @export
 */
export const CardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate unactivated card. It will switch to ACTIVE status and customer can use it for payments.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateCardV3(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateCardV3(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all cards filtered by filter in the request.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {CardsListRequestV3} cardsListRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardsListV3(xCorrelationId: string, cardsListRequestV3: CardsListRequestV3, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardsListResponseV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardsListV3(xCorrelationId, cardsListRequestV3, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set new card\'s daily limit.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {SetLimitRequestV3} setLimitRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCardLimitV3(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, setLimitRequestV3: SetLimitRequestV3, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCardLimitV3(xCorrelationId, bankCardUuid, clientPidUuid, setLimitRequestV3, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Disable or enable given card security.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {SetSecurityRequestV3} setSecurityRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCardSecurityV3(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, setSecurityRequestV3: SetSecurityRequestV3, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCardSecurityV3(xCorrelationId, bankCardUuid, clientPidUuid, setSecurityRequestV3, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Terminate card - it will switch to TERMINATED status and it won\'t be functional anymore.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminateCardV3(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminateCardV3(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unblock PIN on the given card.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} bankCardUuid Uuid of the card.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockPinV3(xCorrelationId: string, bankCardUuid: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unblockPinV3(xCorrelationId, bankCardUuid, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CardsApi - factory interface
 * @export
 */
export const CardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardsApiFp(configuration)
    return {
        /**
         * Activate unactivated card. It will switch to ACTIVE status and customer can use it for payments.
         * @param {CardsApiActivateCardV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCardV3(requestParameters: CardsApiActivateCardV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.activateCardV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get all cards filtered by filter in the request.
         * @param {CardsApiGetCardsListV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardsListV3(requestParameters: CardsApiGetCardsListV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<CardsListResponseV3> {
            return localVarFp.getCardsListV3(requestParameters.xCorrelationId, requestParameters.cardsListRequestV3, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Set new card\'s daily limit.
         * @param {CardsApiSetCardLimitV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCardLimitV3(requestParameters: CardsApiSetCardLimitV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.setCardLimitV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.setLimitRequestV3, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Disable or enable given card security.
         * @param {CardsApiSetCardSecurityV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCardSecurityV3(requestParameters: CardsApiSetCardSecurityV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.setCardSecurityV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.setSecurityRequestV3, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Terminate card - it will switch to TERMINATED status and it won\'t be functional anymore.
         * @param {CardsApiTerminateCardV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCardV3(requestParameters: CardsApiTerminateCardV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.terminateCardV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Unblock PIN on the given card.
         * @param {CardsApiUnblockPinV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPinV3(requestParameters: CardsApiUnblockPinV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.unblockPinV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateCardV3 operation in CardsApi.
 * @export
 * @type CardsApiActivateCardV3Request
 */
export type CardsApiActivateCardV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiActivateCardV3
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiActivateCardV3
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiActivateCardV3
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for getCardsListV3 operation in CardsApi.
 * @export
 * @type CardsApiGetCardsListV3Request
 */
export type CardsApiGetCardsListV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiGetCardsListV3
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {CardsListRequestV3}
     * @memberof CardsApiGetCardsListV3
     */
    readonly cardsListRequestV3: CardsListRequestV3
}

/**
 * Request parameters for setCardLimitV3 operation in CardsApi.
 * @export
 * @type CardsApiSetCardLimitV3Request
 */
export type CardsApiSetCardLimitV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiSetCardLimitV3
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiSetCardLimitV3
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiSetCardLimitV3
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {SetLimitRequestV3}
     * @memberof CardsApiSetCardLimitV3
     */
    readonly setLimitRequestV3: SetLimitRequestV3
}

/**
 * Request parameters for setCardSecurityV3 operation in CardsApi.
 * @export
 * @type CardsApiSetCardSecurityV3Request
 */
export type CardsApiSetCardSecurityV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiSetCardSecurityV3
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiSetCardSecurityV3
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiSetCardSecurityV3
     */
    readonly clientPidUuid: string

    /**
     * 
     * @type {SetSecurityRequestV3}
     * @memberof CardsApiSetCardSecurityV3
     */
    readonly setSecurityRequestV3: SetSecurityRequestV3
}

/**
 * Request parameters for terminateCardV3 operation in CardsApi.
 * @export
 * @type CardsApiTerminateCardV3Request
 */
export type CardsApiTerminateCardV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiTerminateCardV3
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiTerminateCardV3
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiTerminateCardV3
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for unblockPinV3 operation in CardsApi.
 * @export
 * @type CardsApiUnblockPinV3Request
 */
export type CardsApiUnblockPinV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof CardsApiUnblockPinV3
     */
    readonly xCorrelationId: string

    /**
     * Uuid of the card.
     * @type {string}
     * @memberof CardsApiUnblockPinV3
     */
    readonly bankCardUuid: string

    /**
     * 
     * @type {string}
     * @memberof CardsApiUnblockPinV3
     */
    readonly clientPidUuid: string
}

/**
 * CardsApi - object-oriented interface
 * @export
 * @class CardsApi
 * @extends {BaseAPI}
 */
export class CardsApi extends BaseAPI {
    /**
     * Activate unactivated card. It will switch to ACTIVE status and customer can use it for payments.
     * @param {CardsApiActivateCardV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public activateCardV3(requestParameters: CardsApiActivateCardV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).activateCardV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all cards filtered by filter in the request.
     * @param {CardsApiGetCardsListV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public getCardsListV3(requestParameters: CardsApiGetCardsListV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).getCardsListV3(requestParameters.xCorrelationId, requestParameters.cardsListRequestV3, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set new card\'s daily limit.
     * @param {CardsApiSetCardLimitV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public setCardLimitV3(requestParameters: CardsApiSetCardLimitV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).setCardLimitV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.setLimitRequestV3, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disable or enable given card security.
     * @param {CardsApiSetCardSecurityV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public setCardSecurityV3(requestParameters: CardsApiSetCardSecurityV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).setCardSecurityV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, requestParameters.setSecurityRequestV3, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate card - it will switch to TERMINATED status and it won\'t be functional anymore.
     * @param {CardsApiTerminateCardV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public terminateCardV3(requestParameters: CardsApiTerminateCardV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).terminateCardV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unblock PIN on the given card.
     * @param {CardsApiUnblockPinV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardsApi
     */
    public unblockPinV3(requestParameters: CardsApiUnblockPinV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return CardsApiFp(this.configuration).unblockPinV3(requestParameters.xCorrelationId, requestParameters.bankCardUuid, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HoldsApi - axios parameter creator
 * @export
 */
export const HoldsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Manually release the hold. It will release the hold in the core and switch hold status to MANUALLY_RELEASED.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} transactionId Core id of the transaction.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseHoldV3: async (xCorrelationId: string, transactionId: number, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('releaseHoldV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('releaseHoldV3', 'transactionId', transactionId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('releaseHoldV3', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards/v3/holds/{transactionId}/release`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HoldsApi - functional programming interface
 * @export
 */
export const HoldsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HoldsApiAxiosParamCreator(configuration)
    return {
        /**
         * Manually release the hold. It will release the hold in the core and switch hold status to MANUALLY_RELEASED.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {number} transactionId Core id of the transaction.
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseHoldV3(xCorrelationId: string, transactionId: number, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseHoldV3(xCorrelationId, transactionId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HoldsApi - factory interface
 * @export
 */
export const HoldsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HoldsApiFp(configuration)
    return {
        /**
         * Manually release the hold. It will release the hold in the core and switch hold status to MANUALLY_RELEASED.
         * @param {HoldsApiReleaseHoldV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseHoldV3(requestParameters: HoldsApiReleaseHoldV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.releaseHoldV3(requestParameters.xCorrelationId, requestParameters.transactionId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for releaseHoldV3 operation in HoldsApi.
 * @export
 * @type HoldsApiReleaseHoldV3Request
 */
export type HoldsApiReleaseHoldV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof HoldsApiReleaseHoldV3
     */
    readonly xCorrelationId: string

    /**
     * Core id of the transaction.
     * @type {number}
     * @memberof HoldsApiReleaseHoldV3
     */
    readonly transactionId: number

    /**
     * 
     * @type {string}
     * @memberof HoldsApiReleaseHoldV3
     */
    readonly clientPidUuid: string
}

/**
 * HoldsApi - object-oriented interface
 * @export
 * @class HoldsApi
 * @extends {BaseAPI}
 */
export class HoldsApi extends BaseAPI {
    /**
     * Manually release the hold. It will release the hold in the core and switch hold status to MANUALLY_RELEASED.
     * @param {HoldsApiReleaseHoldV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HoldsApi
     */
    public releaseHoldV3(requestParameters: HoldsApiReleaseHoldV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return HoldsApiFp(this.configuration).releaseHoldV3(requestParameters.xCorrelationId, requestParameters.transactionId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenActivationV3: async (xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('tokenActivationV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'tokenReferenceId' is not null or undefined
            assertParamExists('tokenActivationV3', 'tokenReferenceId', tokenReferenceId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('tokenActivationV3', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards/v3/tokens/{tokenReferenceId}/activate`
                .replace(`{${"tokenReferenceId"}}`, encodeURIComponent(String(tokenReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terminate token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenTerminateV3: async (xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('tokenTerminateV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'tokenReferenceId' is not null or undefined
            assertParamExists('tokenTerminateV3', 'tokenReferenceId', tokenReferenceId)
            // verify required parameter 'clientPidUuid' is not null or undefined
            assertParamExists('tokenTerminateV3', 'clientPidUuid', clientPidUuid)
            const localVarPath = `/bank-backofficegateway-cards/v3/tokens/{tokenReferenceId}/terminate`
                .replace(`{${"tokenReferenceId"}}`, encodeURIComponent(String(tokenReferenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (clientPidUuid != null) {
                localVarHeaderParameter['clientPidUuid'] = String(clientPidUuid);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenActivationV3(xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenActivationV3(xCorrelationId, tokenReferenceId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Terminate token via backoffice.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} tokenReferenceId unique reference to visa token
         * @param {string} clientPidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenTerminateV3(xCorrelationId: string, tokenReferenceId: string, clientPidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenTerminateV3(xCorrelationId, tokenReferenceId, clientPidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensApiFp(configuration)
    return {
        /**
         * Activate token via backoffice.
         * @param {TokensApiTokenActivationV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenActivationV3(requestParameters: TokensApiTokenActivationV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.tokenActivationV3(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Terminate token via backoffice.
         * @param {TokensApiTokenTerminateV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenTerminateV3(requestParameters: TokensApiTokenTerminateV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<void> {
            return localVarFp.tokenTerminateV3(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for tokenActivationV3 operation in TokensApi.
 * @export
 * @type TokensApiTokenActivationV3Request
 */
export type TokensApiTokenActivationV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof TokensApiTokenActivationV3
     */
    readonly xCorrelationId: string

    /**
     * unique reference to visa token
     * @type {string}
     * @memberof TokensApiTokenActivationV3
     */
    readonly tokenReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof TokensApiTokenActivationV3
     */
    readonly clientPidUuid: string
}

/**
 * Request parameters for tokenTerminateV3 operation in TokensApi.
 * @export
 * @type TokensApiTokenTerminateV3Request
 */
export type TokensApiTokenTerminateV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof TokensApiTokenTerminateV3
     */
    readonly xCorrelationId: string

    /**
     * unique reference to visa token
     * @type {string}
     * @memberof TokensApiTokenTerminateV3
     */
    readonly tokenReferenceId: string

    /**
     * 
     * @type {string}
     * @memberof TokensApiTokenTerminateV3
     */
    readonly clientPidUuid: string
}

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
    /**
     * Activate token via backoffice.
     * @param {TokensApiTokenActivationV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public tokenActivationV3(requestParameters: TokensApiTokenActivationV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return TokensApiFp(this.configuration).tokenActivationV3(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terminate token via backoffice.
     * @param {TokensApiTokenTerminateV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public tokenTerminateV3(requestParameters: TokensApiTokenTerminateV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return TokensApiFp(this.configuration).tokenTerminateV3(requestParameters.xCorrelationId, requestParameters.tokenReferenceId, requestParameters.clientPidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


